import React from 'react';

const Modal = ({children = null, size, openModal = null}: { children?: any, size?: string, openModal?: any }) => {
  const getModalSize = () => {
    switch(size) {
      case 'lg':
        return "w-[600px]";
      default:
        return "w-96";
    }
  };

  if (openModal) {
    return (
      <div className="fixed inset-0 bg-black/25 flex items-center justify-center backdrop-blur-sm z-40">
        <div className={`section-card bg-white ${getModalSize()}`}>
          {children}
        </div>
      </div>
    );
  }
};

export default Modal;